import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./index.css";
import "./vendor/perfect-scrollbar.css";
import { Provider } from "react-redux";
import store from "./redux/store";
import './i18n'

ReactDOM.render(
  <Provider store={store}>
    <App/>
  </Provider>,document.getElementById("root")
);
